var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_setup.list),function(item){return _c(_setup.CertificateEducationItem,{key:item.externalId,attrs:{"title":item.label,"link":item.link,"year":item.year,"origin":_setup.type==='certificates' ? item.issuer : item.institute}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }